import React, { Component } from "react";
import {
  Wrapper,
  Input,
  PrimaryButton,
  Row,
  Card,
  CardBody,
  Title,
  Copy,
  Form
} from "app/NativeComponents/common";

class AddPromoCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      promo_code: ""
    };
  }

  editPromoCode(value) {
    this.setState({ promo_code: value });
  }

  savePromoCode() {
    this.props.savePartnerInfo({
      token: this.props.token,
      type: "create_promo_code",
      payload: {
        promo: this.state.promo_code,
        partner_id: this.props.partner_info.id
      }
    });

    this.setState({ promo_code: "" });
  }

  render() {
    return (
      <Wrapper>
        <CardBody>
          <Title>New Promo Code Link</Title>
          <Copy>
            Add a new promo code here. This code will generate a link that
            automatically fills in the promo code area for users you want to
            sign up. The promo code is how we track users that you bring on.
          </Copy>
        </CardBody>
        <Form
          onSubmit={() => {
            this.savePromoCode();
          }}
        >
          <Row>
            <Card style={{ flex: 1 }}>
              <Input
                ref={"promo_code"}
                name={"promo_code"}
                placeholder={"Promo Code"}
                onChange={value => {
                  this.editPromoCode(value);
                }}
                value={this.state.promo_code}
                type="text"
              />
            </Card>
            <Card style={{ borderRadius: 30, overflow: "hidden" }}>
              <PrimaryButton
                onPress={() => {
                  this.savePromoCode();
                }}
                formButton
                style={{
                  flex: 1
                }}
              >
                Add Link
              </PrimaryButton>
            </Card>
          </Row>
        </Form>
      </Wrapper>
    );
  }
}

export default AddPromoCode;
